import { ethers } from "ethers";

// Re-export on-chain helpers. Snapshot GraphQL / sequencer APIs have been removed.
export {
  currentEpoch,
  currentProposalId,
  getActiveProposal,
  gaugeTotals,
  withheldWeightsAtEpoch,
  getUserOptOutGauges,
  userOptOutGaugesAtEpoch,
  optOutGauges,
  optInGauges,
  getDelegateAddress,
  delegationStatus,
  getCurrentEpochDelegate,
  setDelegate,
  setConvexDaoDelegate,
  isDaoDelegatedToConvex,
  pollForReceipt,
  getWeightSyncStatus,
  syncDelegation,
  getUserVote,
  balanceAtEpochOf,
  votingPowerAtEpochOf,
  castVote,
} from "./cvxOnchain";

// Returns the first block number whose timestamp is >= epochStartTs.
// Uses a single latest-block fetch to anchor the estimate, then binary searches
// the provider to find the exact boundary — no external APIs, no rate limits.
// ~11 eth_getBlockByNumber calls total against the existing RPC connection.
export async function getBlockByTimestamp(epochStartTs, provider) {
  try {
    const latest = await provider.getBlock("latest");
    const roughBlock =
      latest.number - Math.round((latest.timestamp - epochStartTs) / 12);

    let lo = Math.max(0, roughBlock - 500);
    let hi = roughBlock + 500;

    while (lo + 1 < hi) {
      const mid = Math.floor((lo + hi) / 2);
      const midBlock = await provider.getBlock(mid);
      if (midBlock.timestamp < epochStartTs) {
        lo = mid;
      } else {
        hi = mid;
      }
    }

    return hi;
  } catch {
    console.log("Could not find block by timestamp");
    return null;
  }
}

// Kept for any remaining callers that need a zero-address check helper.
export const ZERO_ADDRESS = ethers.constants.AddressZero;
